// extracted by mini-css-extract-plugin
export default {"tagList":"vjFfwq","accordion-actions":"mFdCz0","reports-accordion":"KWYPIK","report-title-skeleton":"bIIRar"};